import axios from 'axios'
import { env } from '@ivy/fts/envInfo/envInfo'
env.init()
export async function requireGet(url) {
  const info = await env.getInfo()
  if (env.type === 'ivydad') {
    return axios.get(url, {
      params: {
        ...info.publicParams,
      },
    })
  }
  return axios.get(url)
}

export async function requirePost(url, data, config?) {
  const info = await env.getInfo()
  if (env.type === 'ivydad') {
    return axios.post(url, { ...data, ...info.publicParams }, config)
  }
  return axios.post(url, data, config)
}

// 埋点
export async function addStatistics(info) {
  let requestConfig: any = { disableLoading: true, disableAlert: true }
  try {
    await requirePost(
      '/api/activity/appActivity/punchDistributionAc/addstatistics',
      {
        ...info,
      },
      requestConfig
    )
  } catch (error) {
    console.log(error)
  }
}
